import { GooglePlayIcon, AndroidIcon, IosIcon } from '@/app/const/svg';
// 中文背景图
import AppIconZH1 from '@/app/assets/image/download/zh/app-icon-1.png';
import AppIconZH2 from '@/app/assets/image/download/zh/app-icon-2.png';
import AppIconZH4 from '@/app/assets/image/download/zh/app-icon-4.png';
import AppIconZH5 from '@/app/assets/image/download/zh/app-icon-5.png';
import AppMobileZH from '@/app/assets/image/download/zh/app-mobile.png';
// 英文背景图
import AppIconEN1 from '@/app/assets/image/download/en/app-icon-1.png';
import AppIconEN2 from '@/app/assets/image/download/en/app-icon-2.png';
import AppIconEN4 from '@/app/assets/image/download/en/app-icon-4.png';
import AppIconEN5 from '@/app/assets/image/download/en/app-icon-5.png';
import AppMobileEN from '@/app/assets/image/download/en/app-mobile.png';
// 公共的
import AppIcon6 from '@/app/assets/image/download/app-icon-31.png';
import AppIcon7 from '@/app/assets/image/download/app-icon-32.png';
export const DOWNLOAD_LINKS = {
    // ios: 'https://apps.apple.com/ph/app/billion-live/id6753589883', // 菲律宾app
    ios: 'https://apps.apple.com/hk/app/billion-live/id6753589883',  // 香港app
    android: 'https://static.billion.live/apk/BillionLive.apk',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.live.juvo.app',
};

/**
 * 下载信息
 */
export const DOWNLOAD_BUTTONS = [
    { 
        key: 'appStore', 
        icon: IosIcon, 
        labelKey: 'appStore', 
        href: DOWNLOAD_LINKS.ios,
        fullRow: true
    },
    { 
        key: 'android', 
        icon: AndroidIcon, 
        labelKey: 'android', 
        href: DOWNLOAD_LINKS.android
    },
    { 
        key: 'googlePlay', 
        icon: GooglePlayIcon, 
        labelKey: 'googlePlay', 
        href: DOWNLOAD_LINKS.googlePlay, 
    }
];


export const DOWNLOAD_BG = {
    ZH: {
        AppIcon1: AppIconZH1,
        AppIcon2: AppIconZH2,
        AppIcon4: AppIconZH4,
        AppIcon5: AppIconZH5,
        AppIcon6: AppIcon6,
        AppIcon7: AppIcon7,
        AppMobile: AppMobileZH,
    },
    EN: {
        AppIcon1: AppIconEN1,
        AppIcon2: AppIconEN2,
        AppIcon4: AppIconEN4,
        AppIcon5: AppIconEN5,
        AppIcon6: AppIcon6,
        AppIcon7: AppIcon7,
        AppMobile: AppMobileEN,
    }
}